module.exports = "/packs/images/svg/close~5a870a7e65288632a91ba55130fdd3b0.svg";